import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const WelcomeEmailDrip = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <rect
          y="0.445312"
          width="248"
          height="143"
          rx="8.03704"
          fill="#F6F1EB"
        />
        <path
          d="M101.479 64.4062V80.4641L89.6279 72.5537L101.479 64.4062Z"
          fill="#C9DBFF"
        />
        <path
          d="M157.77 72.5544L145.919 80.4648V65.0742L157.77 72.5544Z"
          fill="#C9DBFF"
        />
        <path
          d="M157.77 72.5566V103.665C157.77 104.844 157.302 105.974 156.468 106.807C155.635 107.641 154.505 108.109 153.326 108.109H94.072C92.8933 108.109 91.763 107.641 90.9296 106.807C90.0961 105.974 89.6279 104.844 89.6279 103.665V72.5566L101.479 80.4671L112.648 87.9034L113.33 87.3701H134.068L134.75 87.9034L145.919 80.4671L157.77 72.5566Z"
          fill="#C9DBFF"
        />
        <path
          d="M149.055 40.0516V78.8937L134.975 88.0489L134.197 87.4402H113.201L112.423 88.0489L98.3433 78.8937V40.0516C98.3433 39.1547 98.6995 38.2946 99.3335 37.6604C99.9675 37.0262 100.827 36.6699 101.724 36.6699H145.674C146.571 36.6699 147.431 37.0262 148.065 37.6604C148.699 38.2946 149.055 39.1547 149.055 40.0516Z"
          fill="white"
        />
        <path
          d="M140.531 37.3359H101.357C100.557 37.3359 99.791 37.6525 99.2259 38.2159C98.6607 38.7793 98.3433 39.5435 98.3433 40.3403V78.4059L99.8017 79.3733L141.715 37.5823C141.341 37.4204 140.938 37.3366 140.531 37.3359Z"
          fill="white"
        />
        <path
          d="M149.055 67.3652L157.77 72.5566V103.665C157.77 104.844 157.302 105.974 156.468 106.807C155.635 107.641 154.505 108.109 153.326 108.109H94.072C92.8933 108.109 91.763 107.641 90.9296 106.807C90.0961 105.974 89.6279 104.844 89.6279 103.665V72.5566L98.0095 67.3652"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M98.5161 99.218L113.33 87.3672H134.069L148.882 99.218"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M157.77 72.5566L139.994 84.4074"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M89.6279 72.5566L107.404 84.4074"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M149.055 78.0388V40.351C149.055 39.5513 148.699 38.7844 148.065 38.219C147.431 37.6536 146.571 37.3359 145.674 37.3359H101.724C100.827 37.3359 99.9675 37.6536 99.3335 38.219C98.6995 38.7844 98.3433 39.5513 98.3433 40.351V78.0388"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M110.367 48.8535H116.292"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M116.292 57.7422H137.031"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M110.367 66.6309H137.031"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M110.367 75.5156H137.031"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  })
);
WelcomeEmailDrip.displayName = 'WelcomeEmailDrip';
